if (!customElements.get('product-option-modal')) {
  class ProductOptionModal extends HTMLElement {
    constructor() {
      super();

      this.onOpenerClick = this.onOpenerClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.dialog = this.querySelector('[role="dialog"]');
      const controlsId = this.dialog?.id;
      this.openers = controlsId
        ? Array.from(document.querySelectorAll(`[aria-controls="${controlsId}"]`))
        : [];
      this.closeButtons = this.querySelectorAll('[data-product-option-close]');

      this.openers.forEach((opener) => {
        opener.addEventListener('click', this.onOpenerClick);
      });
      this.closeButtons.forEach((button) => {
        button.addEventListener('click', this.onCloseClick);
      });
      this.addEventListener('click', this.onModalClick);
      this.addEventListener('keyup', this.onKeyUp);

      if (this.parentElement !== document.body) {
        this.isMoving = true;
        document.body.appendChild(this);
        this.isMoving = false;
      }
    }

    disconnectedCallback() {
      if (this.isMoving) return;

      this.openers?.forEach((opener) => {
        opener.removeEventListener('click', this.onOpenerClick);
      });
      this.closeButtons?.forEach((button) => {
        button.removeEventListener('click', this.onCloseClick);
      });
      this.removeEventListener('click', this.onModalClick);
      this.removeEventListener('keyup', this.onKeyUp);

      if (this.hasAttribute('open')) this.hide(false);
    }

    onOpenerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.activeOpener = event.currentTarget;
      this.show();
    }

    onCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }

    onModalClick(event) {
      event.stopPropagation();

      if (event.target === this) this.hide();
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }

    show() {
      if (this.hasAttribute('open')) return;

      document.querySelectorAll('product-option-modal[open]').forEach((modal) => {
        if (modal !== this) modal.hide(false);
      });

      this.lockScroll();
      this.setAttribute('open', '');
      this.openers.forEach((opener) => {
        opener.setAttribute('aria-expanded', 'true');
      });

      if (typeof trapFocus === 'function') {
        trapFocus(this, this.dialog);
      } else {
        this.dialog?.focus();
      }

      window.pauseAllMedia?.();
    }

    hide(restoreFocus = true) {
      if (!this.hasAttribute('open')) return;

      this.removeAttribute('open');
      this.openers.forEach((opener) => {
        opener.setAttribute('aria-expanded', 'false');
      });
      this.unlockScroll();

      if (restoreFocus) {
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.activeOpener || this.openers[0]);
        } else {
          (this.activeOpener || this.openers[0])?.focus();
        }
      } else if (typeof removeTrapFocus === 'function') {
        removeTrapFocus();
      }

      window.pauseAllMedia?.();
    }

    lockScroll() {
      this.bodyOverflowWasHidden = document.body.classList.contains('overflow-hidden');
      this.previousBodyPaddingRight = document.body.style.paddingRight;

      if (this.bodyOverflowWasHidden) return;

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (scrollbarWidth > 0) {
        const currentPaddingRight = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
      }

      document.body.classList.add('overflow-hidden');
    }

    unlockScroll() {
      if (this.bodyOverflowWasHidden) return;

      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = this.previousBodyPaddingRight;
    }
  }

  customElements.define('product-option-modal', ProductOptionModal);
}
